export const GenericLoading = () => {
  return null;

  return (
    <div className="flex w-full flex-col items-center justify-center gap-y-6">
      <div className="flex w-full items-center justify-between">
        <div className={`text-[20px] font-medium dark:text-white`}>
          ...loading
        </div>
      </div>
    </div>
  );
};
